"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _format = _interopRequireDefault(require("date-fns/format"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var statusLabels = {
  flagged: 'Flagged',
  unflagged: 'Unflagged'
};
var FlagHistory = function FlagHistory(props) {
  var history = props.history;
  var columns = [{
    name: 'status',
    label: 'Status',
    render: function render(value, row) {
      return statusLabels[value] || '';
    }
  }, {
    name: 'reason',
    label: 'Reason'
  }, {
    name: 'updatedAt',
    label: 'Updated At',
    render: function render(value, row) {
      return (0, _format["default"])(new Date(value), 'MM/dd/yyyy h:mm a');
    }
  }, {
    name: 'updatedBy',
    label: 'Updated By',
    render: function render(value, row) {
      return row.updatedBy.firstName ? "".concat(row.updatedBy.firstName, " ").concat(row.updatedBy.lastName) : row.updatedBy.email;
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
    columns: columns,
    data: history,
    rowKey: "updatedAt",
    showPerPageOptions: false,
    hideShowingRowsSummary: true
  });
};
FlagHistory.propTypes = {
  history: _propTypes["default"].array,
  closeModal: _propTypes["default"].func
};
var _default = FlagHistory;
exports["default"] = _default;